jQuery(document).ready(function($) {

    /* fix iOS touchmove issue */
    ;
    (function() {
        let touchingCarousel = false
        let startXCoordinate

        document.body.addEventListener('touchstart', e => {
            if (e.target.closest('.flickity-slider')) {
                touchingCarousel = true
            } else {
                touchingCarousel = false
                return
            }
            startXCoordinate = e.touches[0].pageX
        })

        document.body.addEventListener('touchmove', e => {
            if (
                !touchingCarousel ||
                !e.cancelable ||
                Math.abs(e.touches[0].pageX - startXCoordinate) < 8
            ) return
            e.preventDefault()
            e.stopPropagation()
        }, {
            passive: false
        })
    }())

    /* prevent resize in flickity if still animating */
    var resize = Flickity.prototype.resize;
    Flickity.prototype.resize = function() {
        if (!this.isAnimating) {
            resize.call(this);
        }
    };

});

const createSlideshow = (target, config) => {
  const slideshow = new Flickity(target, config);
  // Fix slider bad initialization
  window.dispatchEvent(new Event('resize'));
  return slideshow;
}

document.addEventListener('variantChange', function(event) {
  const variant = event.detail?.variant;
  if (!variant) return;
  const backInStockButton = document.querySelector('.btn.klaviyo-bis-trigger');
  if(backInStockButton && !document.querySelector('[data-stock-notify-ready]')) {
    if(variant.available) {
      backInStockButton.style.display = 'none';
    } else {
      backInStockButton.style.display = 'block';
    }
  }

  const presalePricesEl = document.querySelector('.js-presale-prices');
  if(presalePricesEl) {
    const prices = JSON.parse(presalePricesEl.textContent);
    const presalePrice = prices[variant.id];
    if(presalePrice) {
      const priceContainer = document.querySelector('.product__price [data-price]');
      if(priceContainer) priceContainer.classList.add('price--on-sale');
      const price = document.querySelector('.product__price [data-sale-price]');
      const compareAtPrice = document.querySelector('.product__price .mezcalero-price__compare-at-price');
      if(price) price.textContent = theme.Currency.formatMoney(presalePrice, theme.moneyFormat);
      if(compareAtPrice) compareAtPrice.textContent = theme.Currency.formatMoney(variant.price, theme.moneyFormat);
    }
  }

  const alianzaMapEl = document.querySelector('[data-alianza-only-map]');
  if(alianzaMapEl) {
    const alianzaMap = JSON.parse(alianzaMapEl.textContent);
    const isAlianzaOnly = !!alianzaMap[variant.id];
    const atelierNotice = document.querySelector('[data-atelier-notice]');
    const presaleCard = document.querySelector('[data-presale-card]');
    if(atelierNotice) atelierNotice.style.display = isAlianzaOnly ? '' : 'none';
    if(presaleCard) presaleCard.style.display = isAlianzaOnly ? 'none' : '';
  }
});

function handleCartDrawerControls() {
  const controlType = this.dataset.controlType;
  const wrapper = this.closest('.mezcalero-cart-drawer-item');
  const variantId = wrapper.dataset.variantId;
  const quantity = wrapper.querySelector('.mezcalero-cart-drawer-item__input');
  const cartItemCount = document.querySelector('[data-cart-items]');
  const stockError = wrapper.querySelector('[data-stock-error]');
  stockError.hidden = true;
  let quantityValue = parseInt(quantity.value);
  if(controlType === 'minus') {
    if(parseInt(quantity.value) - 1 === -1) {
      quantityValue = 0;
    } else {
      quantityValue--;
    }
  } else if(controlType === 'plus') {
    quantityValue++;
  }

  let data = {
    'id': variantId,
    'quantity': quantityValue
  };

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => response.json())
  .then(data => {
    if(data.status) {
      stockError.textContent = 'There is no more stock available for this product';
      stockError.hidden = false;
      return;
    }
    if(quantityValue === 0) {
      wrapper.remove();
    }
    cartItemCount.textContent = `( ${data.item_count} Items )`;
    data.items.map(item => {
      if(item.variant_id === parseInt(variantId)) {
        quantity.value = item.quantity;
      }
    });
    const subtotalElement = document.querySelector('[data-cart-drawe-subtotal]');
    subtotalElement.textContent = `${theme.Currency.formatMoney(data.items_subtotal_price, theme.moneyFormat)}`;
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function initCartDrawerControls() {
  const cartDrawerControls = document.querySelectorAll('.mezcalero-cart-drawer-item__qty-control');
  if(cartDrawerControls) {
    cartDrawerControls.forEach(control => control.addEventListener('click', handleCartDrawerControls));
  }
}

initCartDrawerControls();


// Overlay
const overlay = document.querySelector('.mezcalero-overlay');
const hmtlBody = document.querySelector('body');

// Cart drawer
const cartDrawer = document.querySelector('.mezcalero-cart-drawer');

function handleCartDrawer() {
  const cartDrawerOverlay = document.querySelector('.mezcalero-overlay-cart-drawer');
  cartDrawerOverlay.addEventListener('click', handleCartDrawer);
  if(cartDrawer.classList.contains('mezcalero-cart-drawer--active')) {
    cartDrawer.classList.remove('mezcalero-cart-drawer--active');
    cartDrawerOverlay.classList.remove('mezcalero-overlay-cart-drawer--active');
    hmtlBody.style.overflow = '';
  } else {
    cartDrawer.classList.add('mezcalero-cart-drawer--active');
    cartDrawerOverlay.classList.add('mezcalero-overlay-cart-drawer--active');
    hmtlBody.style.overflow = 'hidden';
  }
}

function updateCartDrawerRender() {
  const cartDrawerItemsContainer = document.querySelector('.mezcalero-cart-drawer-items');
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => response.json())
  .then(data => {
    cartDrawerItemsContainer.innerHTML = `
      ${data.items.map(item => `
        <div class="mezcalero-cart-drawer-item" data-variant-id="${item.variant_id}">
          <img class="mezcalero-cart-drawer-item__image" src="${item.featured_image.url}" alt="${item.featured_image.alt}">
          <div class="mezcalero-cart-drawer-item__details">
            <h2 class="mezcalero-cart-drawer-item__title">${item.product_title}</h2>
            <span class="mezcalero-cart-drawer-item__variant-title">${item.variant_title.includes('_#') ? item.variant_title.split('_#')[0] : item.variant_title}</span>
            <h3 class="mezcalero-cart-drawer-item__vendor">${item.vendor}</h3>
            <p class="mezcalero-cart-drawer-item__price">${theme.Currency.formatMoney(item.price, theme.moneyFormat)}</p>
            <div class="mezcalero-cart-drawer-item__qty-controls">
              <span class="mezcalero-cart-drawer-item__qty-control" data-control-type="minus"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20"><path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"></path></svg></span>
              <input class="mezcalero-cart-drawer-item__input" type="text" value="${item.quantity}" readonly>
              <span class="mezcalero-cart-drawer-item__qty-control" data-control-type="plus"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"></path></svg></span>
            </div>
            <span class="mezcalero-cart-drawer-item__stock-error" data-stock-error hidden></span>
          </div>
        </div>
      `).join('')}
    `;
    const subtotalElement = document.querySelector('[data-cart-drawe-subtotal]');
    subtotalElement.textContent = `${theme.Currency.formatMoney(data.items_subtotal_price, theme.moneyFormat)}`;
    initCartDrawerControls();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function initTheme() {
  const productContainers = document.querySelectorAll('.product-template__container, .index-section--mezcalero-featured-product [data-section-type="product"]');
  if(productContainers) {
    productContainers.forEach(product => fetchSizes(product));
  }

  function updateSizeSelector(data, productContainer) {
    const sizeOptions = productContainer.querySelector('.variants-size-options');
    if(sizeOptions) {
      data.variants.map(variant => {
        if(!variant.available) {
          sizeOptions.querySelector(`[data-option-value="${variant.option1}"]`).classList.add('variants-size-options__element--disabled');
        }
      });
      sizeOptions.classList.remove('variants-size-options--hidden');
    }
  }

  function fetchSizes(productContainer) {
    const handle = productContainer.dataset.productHandle;
    fetch(`/products/${handle}.js`)
      .then(response => response.json())
      .then(data => updateSizeSelector(data, productContainer))
      .catch(error => console.log('Error: ', error));
  }

  const presalePricesEl = document.querySelector('.js-presale-prices');
  const presalePrices = presalePricesEl ? JSON.parse(presalePricesEl.textContent) : {};

  const productContainer = document.querySelector('[data-product-template-container]');
  let productVariants = [];
  let productHandle = '';
  if(productContainer) {
    productHandle = productContainer.querySelector('.product-template__container').dataset.productHandle;
    fetch(`/products/${productHandle}.js`)
    .then(response => response.json())
    .then(data => {
      productVariants = data.variants;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  const dropRelatedProductsByGroup = document.querySelector('.related-elements');
  if(dropRelatedProductsByGroup && !dropRelatedProductsByGroup.dataset.colorsLoading && !dropRelatedProductsByGroup.dataset.colorsLoaded) {
    let collectionFetchProducts = [];
    const groupsElement = dropRelatedProductsByGroup.closest('[data-product-related-groups]');
    const colorControls = dropRelatedProductsByGroup.closest('.mezcalero-product-options__color');
    const nativeColors = colorControls.querySelector('.variants-color-swatch');
    const retryColors = colorControls.querySelector('[data-related-colors-retry]');
    if(groupsElement) {
      const groups = groupsElement.dataset.productRelatedGroups;
      groups.split(',').map(group => group.trim()).filter((group, index, groups) => groups.indexOf(group) === index).forEach(group => {
        if(group) {
          const base = dropRelatedProductsByGroup.dataset.groupsUrl || '/collections/all';
          collectionFetchProducts.push(`${base}/${encodeURIComponent(group)}/?view=json`);
        }
      })
    }

    if(collectionFetchProducts.length > 0) {
      async function getProducts(groupUrl) {
        // Retry transient failures once, without leaving the native colors hidden.
        for (let attempt = 0; attempt < 2; attempt++) {
          const abort = new AbortController();
          const timer = setTimeout(() => abort.abort(), 8000);
          try {
            const response = await fetch(groupUrl, { signal: abort.signal });
            if (!response.ok) throw new Error('Color request failed');
            const data = await response.json();
            if (!Array.isArray(data.results) || !data.results.length) throw new Error('Missing colors');
            return data.results;
          } catch (error) {
            if (attempt === 1 || !dropRelatedProductsByGroup.isConnected) throw error;
          } finally {
            clearTimeout(timer);
          }
        }
      }

      const populateRelatedProducts = async () => {
        if (dropRelatedProductsByGroup.dataset.colorsLoading) return;
        dropRelatedProductsByGroup.dataset.colorsLoading = 'true';
        dropRelatedProductsByGroup.setAttribute('aria-busy', 'true');
        if (retryColors) retryColors.hidden = true;
        const responses = await Promise.allSettled(collectionFetchProducts.map(getProducts));
        delete dropRelatedProductsByGroup.dataset.colorsLoading;
        dropRelatedProductsByGroup.removeAttribute('aria-busy');
        if (!dropRelatedProductsByGroup.isConnected) return;
        const products = new Map();
        responses.forEach(result => {
          if (result.status === 'fulfilled') result.value.forEach(product => {
            if (product && typeof product.handle === 'string' && /^[a-z0-9-]+$/.test(product.handle) && product.thumbnail) products.set(product.handle, product);
          });
        });
        if (products.size) {
          const items = Array.from(products.values()).reverse().map(product => {
            const item = document.createElement('a');
            item.className = 'related-elements__item';
            item.classList.toggle('related-elements__item--active', product.handle === productHandle);
            item.dataset.productHandle = product.handle;
            item.href = `${dropRelatedProductsByGroup.dataset.groupsUrl || '/collections/all'}`.replace(/\/collections\/all\/?$/, '') + '/products/' + product.handle;
            item.setAttribute('aria-label', product.title || product.handle);
            const image = document.createElement('img');
            image.className = 'related-elements__item-image';
            image.src = product.thumbnail;
            image.alt = product.title || product.handle;
            item.append(image);
            item.addEventListener('click', handleProductRelated);
            return item;
          });
          dropRelatedProductsByGroup.replaceChildren(...items);
          dropRelatedProductsByGroup.dataset.colorsLoaded = 'true';
          if (nativeColors) nativeColors.classList.add('variants-color-swatch--hidden');
        } else if (nativeColors) {
          nativeColors.classList.remove('variants-color-swatch--hidden');
        }
        if (retryColors) retryColors.hidden = products.size > 0 && responses.every(result => result.status === 'fulfilled');
      }
      if (retryColors) retryColors.onclick = populateRelatedProducts;
      populateRelatedProducts();
    }
  }

  async function handleProductRelated(event) {
    if (event && (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return;
    if (event) event.preventDefault();
    const productRelatedHandle = this.dataset.productHandle;
    const url = this.href || `${theme.shopUrl}/products/${productRelatedHandle}`;
    try {
      const response = await fetch(url);
      const data = await response.text();
      const htmlDoc = new DOMParser().parseFromString(data, 'text/html');
      const newProductTemplateContainer = htmlDoc.querySelector('#ProductSection-product-template');
      if (!newProductTemplateContainer) throw new Error('Product content missing');
      const productTemplateContainer = document.querySelector('[data-product-template-container]');
      productTemplateContainer.innerHTML = '';
      productTemplateContainer.appendChild(newProductTemplateContainer);
      window.history.pushState('', '', url);
      initCartDrawerControls();
      initTheme();
      const loadedProductLayoutEvent = new CustomEvent('productLayoutLoad');
      document.dispatchEvent(loadedProductLayoutEvent);
    } catch(error) {
      window.location.assign(url);
    }
  }

  const collectionTypeSliders = document.querySelectorAll('[data-collection-type]');
  if(collectionTypeSliders) {
    collectionTypeSliders.forEach(element => {
      const config = {
        imagesLoaded: true,
        cellAlign: 'left',
        adaptiveHeight: true,
        pageDots: false,
        prevNextButtons: false,
        watchCSS: true,
        groupCells: true,
        arrowShape: 'M92.5,42.5H25.6L37.8,30.3A7.5,7.5,0,1,0,27.2,19.7l-25,25a7.5,7.5,0,0,0,0,10.6l25,25a7.5,7.5,0,0,0,10.6,0,7.5,7.5,0,0,0,0-10.6L25.6,57.5H92.5a7.5,7.5,0,0,0,0-15Z'
      }
      createSlideshow(element, config);
    });
  }

  const slideshows = document.querySelectorAll('.mezcalero-slideshow');
  if(slideshows) {
    slideshows.forEach(slideshow => {
      const config = {   autoPlay: 5000,
   wrapAround: true,
        imagesLoaded: true,
        fade: true,
        cellAlign: 'left',
        adaptiveHeight: true
      }

      const slideshowInstance = createSlideshow(slideshow, config);
      document.addEventListener('shopify:block:select', (e) => {
        const selectedCell = document.querySelector(`[data-shopify-block-id="${e.detail.blockId}"]`);
        if(selectedCell) {
          slideshowInstance.selectCell(selectedCell);
        }
      });

      // Fix content overlap with the header
      const slideshowsContent = slideshow.querySelectorAll('[data-is-header-overlapping]');
      if(slideshowsContent) {
        slideshowsContent.forEach(content => {
          headerOverlapping(content);
        });
      }
    });
  }

  const brandsSlideshows = document.querySelectorAll('.mezcalero-brands-slideshow');
  if(brandsSlideshows) {
    brandsSlideshows.forEach(slideshow => {
      const config = {
        imagesLoaded: true,
        fade: true,
        cellAlign: 'left',
        groupCells: true,
        prevNextButtons: false
      };
      createSlideshow(slideshow, config);
    });
  }

  const productThumbnails = document.querySelectorAll('[data-product-thumbnails]');
  if(productThumbnails) {
    productThumbnails.forEach(slideshow => {
      const config = {
        imagesLoaded: true,
        cellAlign: 'left',
        groupCells: true,
        pageDots: false,
        arrowShape: 'M92.5,42.5H25.6L37.8,30.3A7.5,7.5,0,1,0,27.2,19.7l-25,25a7.5,7.5,0,0,0,0,10.6l25,25a7.5,7.5,0,0,0,10.6,0,7.5,7.5,0,0,0,0-10.6L25.6,57.5H92.5a7.5,7.5,0,0,0,0-15Z'
      };
      createSlideshow(slideshow, config);
    });
  }

  const cardsSlideshows = document.querySelectorAll('[data-mezcalero-cards-slideshow]');
  if(cardsSlideshows) {
    cardsSlideshows.forEach(slideshow => {
      const config = {
        imagesLoaded: true,
        cellAlign: 'left',
        groupCells: true,
        pageDots: false,
        arrowShape: 'M92.5,42.5H25.6L37.8,30.3A7.5,7.5,0,1,0,27.2,19.7l-25,25a7.5,7.5,0,0,0,0,10.6l25,25a7.5,7.5,0,0,0,10.6,0,7.5,7.5,0,0,0,0-10.6L25.6,57.5H92.5a7.5,7.5,0,0,0,0-15Z'
      };
      createSlideshow(slideshow, config);
    })
  }

  const featuredCollectionsSlideshow = document.querySelectorAll('[data-featured-collection-layout]');
  if(featuredCollectionsSlideshow) {
    featuredCollectionsSlideshow.forEach(slideshow => {
      const config = {
        imagesLoaded: true,
        cellAlign: 'left',
        groupCells: true,
        pageDots: false,
        wrapAround: true,
        arrowShape: 'M92.5,42.5H25.6L37.8,30.3A7.5,7.5,0,1,0,27.2,19.7l-25,25a7.5,7.5,0,0,0,0,10.6l25,25a7.5,7.5,0,0,0,10.6,0,7.5,7.5,0,0,0,0-10.6L25.6,57.5H92.5a7.5,7.5,0,0,0,0-15Z'
      }
      createSlideshow(slideshow, config);
    });
  }

  function featuredCollections() {
    const container = this.closest('.mezcalero-container');
    const tabs = container.querySelectorAll('[data-featured-collection-tab]');
    if(tabs.length > 1) {
      const selectedTab = this.dataset.featuredCollectionTab;
      tabs.forEach(tab => tab.classList.remove('mezcalero-third-heading--featured-collection-active'));
      this.classList.add('mezcalero-third-heading--featured-collection-active');
      const slideshows = container.querySelectorAll('.featured-collection-layout');
      slideshows.forEach(slideshow => slideshow.classList.remove('featured-collection-layout--active'));
      container.querySelector(`[data-featured-collection-tab-content="${selectedTab}"]`).classList.add('featured-collection-layout--active');
    }
  }

  const featuredCollectionHeadings = document.querySelectorAll('[data-featured-collection-tab]');
  if(featuredCollectionHeadings) {
    featuredCollectionHeadings.forEach(heading => heading.addEventListener('click', featuredCollections));
  }

  const imageSlideshows = document.querySelectorAll('[data-image-slideshow]');
  if(imageSlideshows) {
    imageSlideshows.forEach(slideshow => {
      const config = {
        imagesLoaded: true,
        fade: true,
        cellAlign: 'left',
        arrowShape: 'M92.5,42.5H25.6L37.8,30.3A7.5,7.5,0,1,0,27.2,19.7l-25,25a7.5,7.5,0,0,0,0,10.6l25,25a7.5,7.5,0,0,0,10.6,0,7.5,7.5,0,0,0,0-10.6L25.6,57.5H92.5a7.5,7.5,0,0,0,0-15Z',
        adaptiveHeight: true,
        wrapAround: true
      }
      createSlideshow(slideshow, config);

      function dotsPosition() {
        const dots = slideshow.querySelector('.flickity-page-dots');
        const leftSide = slideshow.querySelector('.image-slideshow-slide__left');
        dots.style.left = `${((leftSide.clientWidth - 610) / 2) - 8}px`;
      }

      dotsPosition();

      window.addEventListener('resize', () => {
        dotsPosition();
      });
    });
  }

  function handleVideoPlay() {
    const wrapper = this.closest('.mezcalero-video');
    const iframe = wrapper.querySelector('iframe');
    const videoType = iframe.dataset.videoType;
    iframe.classList.add('mezcalero-video__iframe--active');
    if(videoType === 'youtube') {
      new YT.Player(iframe, {
        events: {
          'onReady': playYouTubeVideo
        }
      });
      function playYouTubeVideo(e) {
        e.target.playVideo();
      }
    } else if(videoType === 'vimeo') {
      const player = new Vimeo.Player(iframe);
      player.setVolume(0);
      player.play();
    }
  }

  const playButtons = document.querySelectorAll('.mezcalero-video__play');
  if(playButtons) {
    playButtons.forEach(button => button.addEventListener('click', handleVideoPlay));
  }

  function variantColorOption() {
    const form = this.closest('form');
    const colorSelect = form.querySelector('[data-select-option-color]');
    const userColorValue = this.dataset.optionValue;
    for(let i = 0; i < colorSelect.options.length; i++) {
      if(userColorValue === colorSelect.options[i].value) {
        colorSelect.selectedIndex = i;
        colorSelect.dispatchEvent(new Event('change'));
      }
    }
    const colorSwatchWrapper = this.closest('.variants-color-swatch');
    const swatches = colorSwatchWrapper.querySelectorAll('.variants-color-swatch__element');
    swatches.forEach(swatch => swatch.classList.remove('variants-color-swatch__element--active'));
    this.classList.add('variants-color-swatch__element--active');
  }

  const variantColorOptions = document.querySelectorAll('.variants-color-swatch__element');
  if(variantColorOptions){
    variantColorOptions.forEach(option => option.addEventListener('click', variantColorOption))
  }

  function variantSizeOptionTarjeta() {
    // if(this.classList.contains('variants-size-options__element--disabled')) return;
    const form = this.closest('form');
    let sizeSelect = form.querySelector('[data-select-option-denominations]');
    const userSizeValue = this.dataset.optionValue;
    for(let i = 0; i < sizeSelect.options.length; i++) {
      if(userSizeValue === sizeSelect.options[i].value) {
        sizeSelect.selectedIndex = i;
        sizeSelect.dispatchEvent(new Event('change'));
      }
    }
    const sizeOptionsWrapper = this.closest('.variants-size-options');
    const sizeOptions = sizeOptionsWrapper.querySelectorAll('.variants-size-options__element');
    sizeOptions.forEach(option => option.classList.remove('variants-size-options__element--active'));
    this.classList.add('variants-size-options__element--active');
    const variantName = `${sizeSelect.value}`;
    const shopifyVariantSelector = document.querySelector('#ProductSelect-product-template');
    productVariants.map(variant => {
      if(variantName === variant.title) {
        const url = `${theme.shopUrl}/products/${productHandle}?variant=${variant.id}`;
        window.history.pushState('', '', url);
        Array.from(shopifyVariantSelector.options).forEach((option, index) => {
          if(parseInt(option.value) == variant.id) {
            shopifyVariantSelector.selectedIndex = index;
          }
        });
        const addToCart = document.querySelector('.mezcalero-add-to-cart');
        const addToCartText = document.querySelector('.mezcalero-add-to-cart [data-add-to-cart-text]');
        if(!variant.available) {
          addToCart.setAttribute('disabled', true);
          addToCartText.textContent = theme.strings.soldOut;
        } else {
          addToCart.removeAttribute('disabled');
          addToCartText.textContent = theme.strings.addToCart;
          const discountBadge = document.querySelector('.mezcalero-discount-badge');
          const price = document.querySelector('.product__price .mezcalero-price__current-price');
          const compareAtPrice = document.querySelector('.product__price .mezcalero-price__compare-at-price');
          const presalePrice = presalePrices[variant.id];
          if(presalePrice) {
            discountBadge.classList.remove('mezcalero-discount-badge--active');
            discountBadge.innerHTML = '';
            price.textContent = theme.Currency.formatMoney(presalePrice, theme.moneyFormat);
            compareAtPrice.textContent = theme.Currency.formatMoney(variant.price, theme.moneyFormat);
          } else if(variant.compare_at_price > variant.price) {
            let calculateOffer = 100 - ((variant.price * 100) / variant.compare_at_price);
            discountBadge.innerHTML = `<span>${Math.ceil(calculateOffer)}% OFF</span>`;
            discountBadge.classList.add('mezcalero-discount-badge--active');
            price.textContent = theme.Currency.formatMoney(variant.price, theme.moneyFormat);
            compareAtPrice.textContent = theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat);
          } else {
            discountBadge.classList.remove('mezcalero-discount-badge--active');
            discountBadge.innerHTML = '';
            price.textContent = theme.Currency.formatMoney(variant.price, theme.moneyFormat);
            compareAtPrice.textContent = '';
          }
        }
      }
    });
  }

  function variantSizeOption() {
    // if(this.classList.contains('variants-size-options__element--disabled')) return;
    const form = this.closest('form');
    let sizeSelect = form.querySelector('[data-select-option-size]');
    const colorSelect = form.querySelector('[data-select-option-color]');
    const userSizeValue = this.dataset.optionValue;
    for(let i = 0; i < sizeSelect.options.length; i++) {
      if(userSizeValue === sizeSelect.options[i].value) {
        sizeSelect.selectedIndex = i;
        sizeSelect.dispatchEvent(new Event('change'));
      }
    }

    const sizeOptionsWrapper = this.closest('.variants-size-options');
    const sizeOptions = sizeOptionsWrapper.querySelectorAll('.variants-size-options__element');
    sizeOptions.forEach(option => option.classList.remove('variants-size-options__element--active'));
    this.classList.add('variants-size-options__element--active');
    const variantName = `${sizeSelect.value} / ${colorSelect.value}`;
    const shopifyVariantSelector = document.querySelector('#ProductSelect-product-template');
    productVariants.map(variant => {
      if(variantName === variant.title) {
        const url = `${theme.shopUrl}/products/${productHandle}?variant=${variant.id}`;
        window.history.pushState('', '', url);
        Array.from(shopifyVariantSelector.options).forEach((option, index) => {
          if(parseInt(option.value) == variant.id) {
            shopifyVariantSelector.selectedIndex = index;
          }
        });
        const addToCart = document.querySelector('.mezcalero-add-to-cart');
        const addToCartText = document.querySelector('.mezcalero-add-to-cart [data-add-to-cart-text]');
        if(!variant.available) {
          addToCart.setAttribute('disabled', true);
          addToCartText.textContent = theme.strings.soldOut;
        } else {
          addToCart.removeAttribute('disabled');
          addToCartText.textContent = theme.strings.addToCart;
          const discountBadge = document.querySelector('.mezcalero-discount-badge');
          const price = document.querySelector('.product__price .mezcalero-price__current-price');
          const compareAtPrice = document.querySelector('.product__price .mezcalero-price__compare-at-price');
          const presalePrice = presalePrices[variant.id];
          if(presalePrice) {
            discountBadge.classList.remove('mezcalero-discount-badge--active');
            discountBadge.innerHTML = '';
            price.textContent = theme.Currency.formatMoney(presalePrice, theme.moneyFormat);
            compareAtPrice.textContent = theme.Currency.formatMoney(variant.price, theme.moneyFormat);
          } else if(variant.compare_at_price > variant.price) {
            let calculateOffer = 100 - ((variant.price * 100) / variant.compare_at_price);
            discountBadge.innerHTML = `<span>${Math.ceil(calculateOffer)}% OFF</span>`;
            discountBadge.classList.add('mezcalero-discount-badge--active');
            price.textContent = theme.Currency.formatMoney(variant.price, theme.moneyFormat);
            compareAtPrice.textContent = theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat);
          } else {
            discountBadge.classList.remove('mezcalero-discount-badge--active');
            discountBadge.innerHTML = '';
            price.textContent = theme.Currency.formatMoney(variant.price, theme.moneyFormat);
            compareAtPrice.textContent = '';
          }
        }
      }
    });
  }

  const variantSizeOptions = document.querySelectorAll('.variants-size-options__element');
  if(variantSizeOptions) {
    if(document.querySelector('[data-select-option-size]') == null){
      variantSizeOptions.forEach(option => option.addEventListener('click', variantSizeOptionTarjeta));
    }else{
      variantSizeOptions.forEach(option => option.addEventListener('click', variantSizeOption));
    }
  }

  const blogPostSlideshows = document.querySelectorAll('[data-blog-post-slideshow]');
  if(blogPostSlideshows) {
    blogPostSlideshows.forEach(slideshow => {
      const config = {
        imagesLoaded: true,
        cellAlign: 'left',
        groupCells: true,
        adaptiveHeight: true,
        arrowShape: 'M92.5,42.5H25.6L37.8,30.3A7.5,7.5,0,1,0,27.2,19.7l-25,25a7.5,7.5,0,0,0,0,10.6l25,25a7.5,7.5,0,0,0,10.6,0,7.5,7.5,0,0,0,0-10.6L25.6,57.5H92.5a7.5,7.5,0,0,0,0-15Z'
      };
      createSlideshow(slideshow, config);
    });
  }

  const relatedArticlesSlideshow = document.querySelector('[data-related-articles-slideshow]');
  if(relatedArticlesSlideshow) {
    const config = {
      imagesLoaded: true,
      cellAlign: 'left',
      groupCells: true,
      adaptiveHeight: true,
      pageDots: false,
      arrowShape: {
        x0: 10,
        x1: 60, y1: 50,
        x2: 70, y2: 40,
        x3: 30
      }
    };
    createSlideshow(relatedArticlesSlideshow, config);
  }

  const gallerySlideshows = document.querySelectorAll('[data-gallery-slideshow]');
  if(gallerySlideshows) {
    gallerySlideshows.forEach(slideshow => {
      const config = {
        imagesLoaded: true,
        cellAlign: 'left',
        groupCells: true,
        adaptiveHeight: true,
        pageDots: false,
        wrapAround: true,
        arrowShape: 'M92.5,42.5H25.6L37.8,30.3A7.5,7.5,0,1,0,27.2,19.7l-25,25a7.5,7.5,0,0,0,0,10.6l25,25a7.5,7.5,0,0,0,10.6,0,7.5,7.5,0,0,0,0-10.6L25.6,57.5H92.5a7.5,7.5,0,0,0,0-15Z'
      };
      createSlideshow(slideshow, config);
    });
  }

  const reviewsSlideshows = document.querySelectorAll('[data-reviews-slideshow]');
  if(reviewsSlideshows) {
    reviewsSlideshows.forEach(slideshow => {
      const config = {
        cellAlign: 'left',
        groupCells: true,
        adaptiveHeight: true,
        wrapAround: true,
        arrowShape: 'M92.5,42.5H25.6L37.8,30.3A7.5,7.5,0,1,0,27.2,19.7l-25,25a7.5,7.5,0,0,0,0,10.6l25,25a7.5,7.5,0,0,0,10.6,0,7.5,7.5,0,0,0,0-10.6L25.6,57.5H92.5a7.5,7.5,0,0,0,0-15Z'
      };
      createSlideshow(slideshow, config);
    });
  }

  const announcementBarClose = document.querySelector('.header-announcement-bar__close');
  if(announcementBarClose) {
    const announcementBar = document.querySelector('.header-announcement-bar');
    announcementBarClose.addEventListener('click', () => {
      if(announcementBar) {
        announcementBar.remove();
      }
    });
  }

  function mobileDrawerSubMenus() {
    const liParent = this.closest('li');
    const subMenu = liParent.querySelectorAll('ul')[0];
    if(subMenu.classList.contains('mezcalero-mobile-menu-level-2')) {
      if(subMenu.classList.contains('mezcalero-mobile-menu-level-2--active')) {
        subMenu.classList.remove('mezcalero-mobile-menu-level-2--active');
        subMenu.style.maxHeight = '0';
      } else {
        subMenu.classList.add('mezcalero-mobile-menu-level-2--active');
        subMenu.style.maxHeight = `${subMenu.scrollHeight}px`;
      }
    } else if(subMenu.classList.contains('mezcalero-mobile-menu-level-3')) {
      if(subMenu.classList.contains('mezcalero-mobile-menu-level-3--active')) {
        subMenu.classList.remove('mezcalero-mobile-menu-level-3--active');
        subMenu.style.maxHeight = '0';
      } else {
        subMenu.classList.add('mezcalero-mobile-menu-level-3--active');
        subMenu.style.maxHeight = `${subMenu.scrollHeight + 25}px`;

        // Update parent
        const menuParent = subMenu.closest('.mezcalero-mobile-menu-level-2');
        menuParent.style.maxHeight = `${menuParent.scrollHeight + subMenu.scrollHeight + 40}px`;
      }
    }
  }

  const mobileMenuTriggers = document.querySelectorAll('.mezcalero-mobile-menu__trigger');
  if(mobileMenuTriggers) {
    mobileMenuTriggers.forEach(menu => menu.addEventListener('click', mobileDrawerSubMenus));
  }

  function handleNavigationSidebar() {
    hmtlBody.scrollIntoView({ behavior: 'smooth', block: 'start' });
    hmtlBody.style.overflow = 'hidden';
    const sidebar = document.querySelector('.mezcalero-mobile-drawer');
    sidebar.classList.add('mezcalero-mobile-drawer--active');
    window.addEventListener('resize', () => {
      if(window.innerWidth > 769) {
        handleCloseNavigationSidebar();
      }
    });
  }

  const navigationSidebarTrigger = document.querySelector('[data-navigation-sidebar]');
  if(navigationSidebarTrigger) {
    navigationSidebarTrigger.addEventListener('click', handleNavigationSidebar);
  }

  function handleCloseNavigationSidebar() {
    hmtlBody.style.overflow = '';
    const sidebar = document.querySelector('.mezcalero-mobile-drawer');
    sidebar.classList.remove('mezcalero-mobile-drawer--active');
  }

  const closeNavigationSidebarTrigger = document.querySelector('.mezcalero-mobile-drawer__close');
  if(closeNavigationSidebarTrigger) {
    closeNavigationSidebarTrigger.addEventListener('click', handleCloseNavigationSidebar)
  }

  function handleCloseMegaMenu() {
    this.classList.remove('header-mega-menu--active');
  }

  function handleMegaMenu() {
    const activeMegaMenus = document.querySelectorAll('.header-mega-menu--active');
    if(activeMegaMenus) {
      activeMegaMenus.forEach(menu => menu.classList.remove('header-mega-menu--active'));
    }
    const megaMenu = this.querySelector('.header-mega-menu');
    if(megaMenu) {
      megaMenu.classList.add('header-mega-menu--active');
      megaMenu.addEventListener('mouseleave', handleCloseMegaMenu);
      megaMenu.addEventListener('mouseover', handleMegaMenu);
    }
  }

  const megaMenuTriggers = document.querySelectorAll('.header-main-navigation__menu__first-level');
  if(megaMenuTriggers) {
    megaMenuTriggers.forEach(trigger => trigger.addEventListener('mouseover', handleMegaMenu));
  }

  function handleStoreSelector() {
    const url = this.value;
    window.location = url;
  }

  const storeSelector = document.querySelector('.mezcalero-top-bar__select');
  if(storeSelector) {
    storeSelector.addEventListener('change', handleStoreSelector);
  }

  const storeTopBar = document.querySelector('.mezcalero-top-bar');
  if(storeTopBar) {
    const topBarCookie = Cookies.get('store_location');
    if(!topBarCookie) {
      storeTopBar.classList.add('mezcalero-top-bar--active');
    }
  }

  function handleCloseTopBar() {
    const cookieExpiration = 7;
    Cookies.set('store_location', 'true', { expires: cookieExpiration });
    storeTopBar.classList.remove('mezcalero-top-bar--active');
  }

  const closeTopBar = document.querySelector('.mezcalero-top-bar__close');
  if(closeTopBar) {
    closeTopBar.addEventListener('click', handleCloseTopBar);
  }

  function handleHeaderSearch() {
    const searchBar = document.querySelector('.mezcalero-search');
    if(searchBar) {
      searchBar.classList.add('mezcalero-search--active');
    }
  }

  const headerSearchTrigger = document.querySelector('[data-header-search]');
  if(headerSearchTrigger) {
    headerSearchTrigger.addEventListener('click', handleHeaderSearch);
  }

  const productBannerSlideshows = document.querySelectorAll('[data-product-banner-slideshow]');
  if(productBannerSlideshows) {
    productBannerSlideshows.forEach(slideshow => {
      const config = {
        imagesLoaded: true,
        cellAlign: 'left',
        pageDots: false,
        wrapAround: true,
        arrowShape: 'M92.5,42.5H25.6L37.8,30.3A7.5,7.5,0,1,0,27.2,19.7l-25,25a7.5,7.5,0,0,0,0,10.6l25,25a7.5,7.5,0,0,0,10.6,0,7.5,7.5,0,0,0,0-10.6L25.6,57.5H92.5a7.5,7.5,0,0,0,0-15Z',
        fade: true,
        on: {
          change: function(index) {
            const selectedHeading = document.querySelector(`[data-banner-heading-index="${index}"]`);
            selectedHeading.click();
          }
        }
      };

      const productBannerSlideshow = createSlideshow(slideshow, config);

      function handleProductBannerHeadings(e) {
        if(e.isTrusted) {
          const container = e.target.closest('.product-banner-slideshow-card__heading');
          if(container) {
            const index = container.dataset.bannerHeadingIndex;
            productBannerSlideshow.select(parseInt(index));
          }
        }
      }

      const productBannerHeadings = document.querySelectorAll('[data-banner-heading-index]');
      if(productBannerHeadings) {
        productBannerHeadings.forEach(heading => heading.addEventListener('click', (e) => handleProductBannerHeadings(e)));
      }
    });
  }

  function handleBannerContent() {
    const wrapper = this.closest('.product-banner-slideshow-card');
    const headings = wrapper.querySelectorAll('.product-banner-slideshow-card__heading');
    headings.forEach(heading => heading.classList.remove('product-banner-slideshow-card__heading--active'));
    this.classList.add('product-banner-slideshow-card__heading--active');
    const headingIndex = this.dataset.bannerHeadingIndex;
    const descriptions = wrapper.querySelectorAll('[data-banner-description-index]');
    descriptions.forEach(description => {
      if(description === wrapper.querySelector(`[data-banner-description-index='${headingIndex}']`)) {
        description.classList.add('product-banner-slideshow-card__description--active');
      } else {
        description.classList.remove('product-banner-slideshow-card__description--active');
      }
    })
  }

  const productBannerHeadings = document.querySelectorAll('.product-banner-slideshow-card__heading');
  if(productBannerHeadings) {
    productBannerHeadings.forEach(heading => {
      heading.addEventListener('click', handleBannerContent);
    });
  }

  function handleFaqCategory() {
    const categoryType = this.dataset.categoryType;
    const categories = document.querySelectorAll('.mezcalero-faq-main__faqs-category');
    faqCategories.forEach(faqCategory => faqCategory.classList.remove('mezcalero-faq-main__category--active'));
    this.classList.add('mezcalero-faq-main__category--active');
    categories.forEach(category => {
      if(category === document.querySelector(`[data-faq-category-type="${categoryType}"]`)) {
        category.classList.add('mezcalero-faq-main__faqs-category--active');
      } else {
        category.classList.remove('mezcalero-faq-main__faqs-category--active');
      }
    });
  }

  const faqCategories = document.querySelectorAll('[data-category-type]');
  if(faqCategories) {
    faqCategories.forEach(faqCategory => faqCategory.addEventListener('click', handleFaqCategory));
  }

  function handleFaqItem() {
    const wrapper = this.closest('.mezcalero-faq-main__faq');
    const answer = wrapper.querySelector('.mezcalero-faq-main__answer');
    if(answer.classList.contains('mezcalero-faq-main__answer--active')) {
      answer.classList.remove('mezcalero-faq-main__answer--active');
    } else {
      answer.classList.add('mezcalero-faq-main__answer--active');
    }
  }

  const faqItems = document.querySelectorAll('.mezcalero-faq-main__faq-heading-wrapper');
  if(faqItems) {
    faqItems.forEach(faq => faq.addEventListener('click', handleFaqItem));
  }

  // PhotoSwipe
  var initPhotoSwipeFromDOM = function(gallerySelector) {

	// parse slide data (url, title, size ...) from DOM elements
	// (children of gallerySelector)
	var parseThumbnailElements = function(el) {
			// var thumbElements = el.childNodes;
			var thumbsArray = [];
			var thumbsNodeListArray = [];
			el.querySelectorAll('.product-single__media').forEach(node => thumbsArray.push(Array.from(node.childNodes)));
			thumbsArray.map(node => node.map(innerNode => thumbsNodeListArray.push(innerNode)));
			var thumbElements = thumbsNodeListArray;
			var numNodes = thumbElements.length;
			var items = [];
			var figureEl;
			var linkEl;
			var size;
			var item;

			for(var i = 0; i < numNodes; i++) {

					figureEl = thumbElements[i]; // <figure> element

					// include only element nodes
					if(figureEl.nodeType !== 1) {
							continue;
					}

					linkEl = figureEl.children[0]; // <a> element

					size = linkEl.getAttribute('data-size').split('x');

					// create slide object
					item = {
							src: linkEl.getAttribute('href'),
							w: parseInt(size[0], 10),
							h: parseInt(size[1], 10)
					};

					if(figureEl.children.length > 1) {
							// <figcaption> content
							item.title = figureEl.children[1].innerHTML;
					}

					if(linkEl.children.length > 0) {
							// <img> thumbnail element, retrieving thumbnail url
							item.msrc = linkEl.children[0].getAttribute('src');
					}

					item.el = figureEl; // save link to element for getThumbBoundsFn
					items.push(item);
			}

			return items;
	};

	// find nearest parent element
	var closest = function closest(el, fn) {
			return el && ( fn(el) ? el : closest(el.parentNode, fn) );
	};

	// triggers when user clicks on thumbnail
	var onThumbnailsClick = function(e) {
			e = e || window.event;
			e.preventDefault ? e.preventDefault() : e.returnValue = false;

			var eTarget = e.target || e.srcElement;

			// find root element of slide
			var clickedListItem = closest(eTarget, function(el) {
				return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
			});

			if(!clickedListItem) {
					return;
			}

			// find index of clicked item by looping through all child nodes
			// alternatively, you may define index via data- attribute
			var clickedGallery = clickedListItem.closest('.mezcalero-photoswipe-gallery');
			// var childNodes = clickedListItem.closest('.mezcalero-photoswipe-gallery').childNodes;
			var thumbsArray = [];
			var thumbsNodeListArray = [];
			clickedListItem.closest('.mezcalero-photoswipe-gallery').querySelectorAll('.product-single__media').forEach(node => thumbsArray.push(Array.from(node.childNodes)));
			thumbsArray.map(node => node.map(innerNode => thumbsNodeListArray.push(innerNode)));
			var childNodes = thumbsNodeListArray;
			var numChildNodes = childNodes.length;
			var	nodeIndex = 0;
			var index;

			for (var i = 0; i < numChildNodes; i++) {
					if(childNodes[i].nodeType !== 1) {
							continue;
					}

					if(childNodes[i] === clickedListItem) {
							index = nodeIndex;
							break;
					}
					nodeIndex++;
			}

			if(index >= 0) {
					// open PhotoSwipe if valid index found
					openPhotoSwipe( index, clickedGallery );
			}
			return false;
	};

	// parse picture index and gallery index from URL (#&pid=1&gid=2)
	var photoswipeParseHash = function() {
			var hash = window.location.hash.substring(1),
			params = {};

			if(hash.length < 5) {
					return params;
			}

			var vars = hash.split('&');
			for (var i = 0; i < vars.length; i++) {
					if(!vars[i]) {
							continue;
					}
					var pair = vars[i].split('=');
					if(pair.length < 2) {
							continue;
					}
					params[pair[0]] = pair[1];
			}

			if(params.gid) {
					params.gid = parseInt(params.gid, 10);
			}

			return params;
	};

	var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
			var pswpElement = document.querySelectorAll('.pswp')[0],
					gallery,
					options,
					items;

			items = parseThumbnailElements(galleryElement);

			// define options (if needed)
			options = {
					shareEl: false,
          fullscreenEl: false,

					// define gallery index (for URL)
					galleryUID: galleryElement.getAttribute('data-pswp-uid'),

					getThumbBoundsFn: function(index) {
							// See Options -> getThumbBoundsFn section of documentation for more info
							var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
									pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
									rect = thumbnail.getBoundingClientRect();

							return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
					}

			};

			// PhotoSwipe opened from URL
			if(fromURL) {
					if(options.galleryPIDs) {
							// parse real index when custom PIDs are used
							// http://photoswipe.com/documentation/faq.html#custom-pid-in-url
							for(var j = 0; j < items.length; j++) {
									if(items[j].pid == index) {
											options.index = j;
											break;
									}
							}
					} else {
							// in URL indexes start from 1
							options.index = parseInt(index, 10) - 1;
					}
			} else {
					options.index = parseInt(index, 10);
			}

			// exit if index not found
			if( isNaN(options.index) ) {
					return;
			}

			if(disableAnimation) {
					options.showAnimationDuration = 0;
			}

			// Pass data to PhotoSwipe and initialize it
			gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
			gallery.init();
	};

	// loop through all gallery elements and bind events
	var galleryElements = document.querySelectorAll( gallerySelector );

	for(var i = 0, l = galleryElements.length; i < l; i++) {
			galleryElements[i].setAttribute('data-pswp-uid', i+1);
			galleryElements[i].onclick = onThumbnailsClick;
	}

	// Parse URL and open gallery if it contains #&pid=3&gid=1
	var hashData = photoswipeParseHash();
	if(hashData.pid && hashData.gid) {
			openPhotoSwipe( hashData.pid ,  galleryElements[ hashData.gid - 1 ], true, true );
	}
	};

	// execute above function
	initPhotoSwipeFromDOM('.mezcalero-photoswipe-gallery');

  // Cart drawer
  const cartDrawerTriggers = document.querySelectorAll('[data-cart-drawer]');
  if(cartDrawerTriggers) {
    cartDrawerTriggers.forEach(trigger => trigger.addEventListener('click', handleCartDrawer))
  }

  const closeCartDrawer = document.querySelector('[data-cart-drawer-close]');
  closeCartDrawer.addEventListener('click', handleCartDrawer);


  function handleCartNote() {
    const cartNoteWrapper = document.querySelector('.mezcalero-cart-drawer__note-fields-wrapper');
    cartNoteWrapper.classList.toggle('mezcalero-cart-drawer__note-fields-wrapper--active');
  }

  const cartNoteOpen = document.querySelector('.mezcalero-cart-drawer__note-heading-wrapper');
  cartNoteOpen.addEventListener('click', handleCartNote);

  const closeGiftNote = document.querySelector('[data-close-gift-note]');
  closeGiftNote.addEventListener('click', handleCartNote);

  function updateGiftNote() {
    const cartNoteInput = document.querySelector('.mezcalero-cart-drawer__note-input');
    let cartNote = {
      note: cartNoteInput.value
    };

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(cartNote)
    })
    .then(response => response.json())
    .then(data => {
      const carteNoteHeading = document.querySelector('.mezcalero-cart-drawer__note-heading');
      if(data.note == '') {
        carteNoteHeading.textContent = "Add a gift note";
      } else {
        carteNoteHeading.textContent = "Edit gift note";
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  const saveCartNote = document.querySelector('[data-save-gift-note]');
  saveCartNote.addEventListener('click', updateGiftNote);

  function handleCartDrawerSubmit(e) {
    const cartDrawerTerms = document.querySelector('[data-cart-terms-input]');
    if(cartDrawerTerms.checked !== true) {
      e.preventDefault();
      const messageContainer = document.querySelector('[data-cart-drawer-required-field]');
      messageContainer.textContent = "You must agree the terms and conditions.";
    }
  }

  const cartDrawerSubmit = document.querySelector('.mezcalero-cart-drawer__submit');
  if(cartDrawerSubmit) {
    cartDrawerSubmit.addEventListener('click', handleCartDrawerSubmit);
  }

  function handleSizeGuide() {
    const wrapper = this.closest('form');
    const sizeGuideHtml = wrapper.querySelector('.size-guide-html-content .size-guide__wrapper');
    const productTitle = wrapper.querySelector('.size-guide-html-content').dataset.mezcaleroProductTitle;
    const sizeGuideModal = document.querySelector('.size-guide');
    var clonedElement = sizeGuideHtml.cloneNode(true);
    clonedElement.querySelector('.size-guide-image-container h2').textContent = "Find your size";
    clonedElement.querySelector('.size-guide-table-container h2').textContent = productTitle;
    sizeGuideModal.appendChild(clonedElement);
    overlay.classList.add('mezcalero-overlay--active');
    sizeGuideModal.classList.add('size-guide--active');
    hmtlBody.style.overflow = 'hidden';
    const closeSizeGuideTriggers = document.querySelectorAll('.size-guide__close');
    if(closeSizeGuideTriggers) {
      closeSizeGuideTriggers.forEach(trigger => trigger.addEventListener('click', handleCloseSizeGuide));
    }
    overlay.addEventListener('click', handleCloseSizeGuide);
  }

  const sizeGuideTrigger = document.querySelectorAll('.variants-option-heading--size-guide');
  if(sizeGuideTrigger) {
    sizeGuideTrigger.forEach(trigger => trigger.addEventListener('click', handleSizeGuide));
  }

  function handleCloseSizeGuide() {
    const sizeGuide = document.querySelector('.size-guide--active');
    if(sizeGuide) {
      sizeGuide.classList.remove('size-guide--active');
      overlay.classList.remove('mezcalero-overlay--active');
      hmtlBody.style.overflow = '';
      setTimeout(() => {
        sizeGuide.innerHTML = '';
      }, 500);
    }
  }

  const cookieBarSection = document.querySelector('.mezcalero-cookie-bar');

  function handleCookieBar() {
    if(cookieBarSection) {
      const cookieExpiration = 7;
      Cookies.set('cookies_privacy', 'true', { expires: cookieExpiration });
      cookieBarSection.classList.remove('mezcalero-cookie-bar--active');
    }
  }

  function showCookieBar() {
    const cookiesPolicy = Cookies.get('cookies_privacy');
    if(!cookiesPolicy){
      cookieBarSection.classList.add('mezcalero-cookie-bar--active');
    }
  }

  if(cookieBarSection) {
    showCookieBar();
  }

  const cookieBarAgree = document.querySelector('[data-cookie-bar-agree]');
  if(cookieBarAgree){
    cookieBarAgree.addEventListener('click', handleCookieBar);
  }

  function handleProductDescription() {
    const wrapper = this.closest('.mezcalero-product-description__item');
    if(wrapper) {
      wrapper.classList.toggle('mezcalero-product-description__item--active');
    }
  }

  const productDescriptions = document.querySelectorAll('.mezcalero-product-description__heading');
  if(productDescriptions) {
    productDescriptions.forEach(description => description.addEventListener('click', handleProductDescription));
  }

  const filtersCloseButton = document.querySelector('[data-filters-close]');
  const openFiltersButton = document.querySelector('#topbar-show-filters');
  const collectionFilters = document.querySelector('.collection-filters-mobile');
  if(filtersCloseButton) {
    filtersCloseButton.addEventListener('click', function() {
      collectionFilters.classList.remove('collection-filters-mobile--active');
      hmtlBody.style.overflow = '';
    });
  }
  if(openFiltersButton) {
    openFiltersButton.addEventListener('click', function() {
      collectionFilters.classList.add('collection-filters-mobile--active');
      const filtersHTML = document.querySelector('.topbar-filter__values');
      const filtersHTMLClone = filtersHTML.cloneNode(true);
      const filtersDrawer = document.querySelector('.collection-filters-mobile__wrapper');
      filtersDrawer.innerHTML = '';
      filtersDrawer.appendChild(filtersHTMLClone);
      hmtlBody.style.overflow = 'hidden';
      const filterLinks = document.querySelectorAll('.topbar-filter__tag a');
      if(filterLinks) {
        filterLinks.forEach(filterLink => filterLink.addEventListener('click', (e) => handleFilterLink(e)))
      }
    });
  }

  window.addEventListener('resize', function() {
    if(window.innerWidth > 749) {
      if(collectionFilters.classList.contains('collection-filters-mobile--active')) {
        collectionFilters.classList.remove('collection-filters-mobile--active');
        hmtlBody.style.overflow = '';
      }
    }
  });

  const collectionURL = document.querySelector('.collection-filters-mobile').dataset.collectionUrl;

  function handleFilterLink(e) {
    if(window.innerWidth <= 749) {
      e.preventDefault();
      const li = e.target.closest('li');
      li.classList.toggle('tag-filter--active');
    }
  }

  function applyFilters() {
    const filterTags = [];
    const activeFilters = document.querySelectorAll('.collection-filters-mobile .topbar-filter__tag.tag-filter--active');
    let builtURL = '';
    if(activeFilters) {
      activeFilters.forEach(activeFilter => {
        const tag = activeFilter.dataset.handleTag;
        filterTags.push(tag);
      });
    }
    filterTags.map((tag, index) => {
      if(index === 0) {
        builtURL = `${tag}`;
      } else {
        builtURL = `${builtURL}+${tag}`;
      }
    });

    window.location.href = `${collectionURL}/${builtURL}`;
  }

  function clearFilters() {
    window.location.href = `${collectionURL}`;
  }

  const applyFiltersButton = document.querySelector('.collection-filters-mobile__apply');
  applyFiltersButton.addEventListener('click', applyFilters);
  const clearFiltersButton = document.querySelector('.collection-filters-mobile__clear');
  clearFiltersButton.addEventListener('click', clearFilters);
};

// Filter on collection layout
function handleClickFilterKey() {
  const key = event.target.dataset.key;
  const filter_values = document.querySelectorAll('.topbar-filter__tag[data-key-rel]');
  const wrapper_values = document.querySelector('.topbar-filter__values');
  const wrapper_current = document.querySelector('.topbar-filter__current');
  const filter_keys = document.querySelectorAll('.topbar-filter-key');

  if(filter_keys) {
    filter_keys.forEach(key => {
      key.classList.remove('topbar-filter--activate-key');
    });
  }

  this.classList.add('topbar-filter--activate-key');

  if(filter_values) {
    filter_values.forEach(tag => {

      if (tag.dataset.keyRel != key) {
        tag.style.setProperty('display', 'none');
      } else {
        tag.style.setProperty('display', 'block');
      }

    });
  }

  wrapper_values.classList.add('topbar-filter---open-values');
  wrapper_current.classList.remove('topbar-filter---open-current');
};

function handleClickCurrentFilter() {
  const wrapper_current = document.querySelector('.topbar-filter__current');
  const wrapper_values = document.querySelector('.topbar-filter__values');

  wrapper_values.classList.remove('topbar-filter---open-values');
  wrapper_current.classList.add('topbar-filter---open-current');
};

function handleClickShowFilter() {
  const wrapper_values = document.querySelector('.topbar-filter__values');
  const show_button = document.querySelector('#topbar-show-filters');
  const hide_button = document.querySelector('#topbar-hide-filters');

  // show_button.style.setProperty('display', 'none');
  // hide_button.style.setProperty('display', 'block');

  // wrapper_values.classList.add('topbar-filter__values--open');
}

function handleClickHideFilter() {
  const wrapper_values = document.querySelector('.topbar-filter__values');
  const show_button = document.querySelector('#topbar-show-filters');
  const hide_button = document.querySelector('#topbar-hide-filters');

  // show_button.style.setProperty('display', 'block');
  // hide_button.style.setProperty('display', 'none');

  // wrapper_values.classList.remove('topbar-filter__values--open');
}

function topbarFilter() {
  // console.log('Collection layout loaded');

  const filter_keys = document.querySelectorAll('.topbar-filter-key');
  if(filter_keys) {
    filter_keys.forEach(key => key.addEventListener('click', handleClickFilterKey));
  }

  const filter_current = document.querySelector('.topbar-filter-current');
  if(filter_current) {
    filter_current.addEventListener('click', handleClickCurrentFilter)
  }

  const show_filters = document.querySelector('#topbar-show-filters');
  const hide_filters = document.querySelector('#topbar-hide-filters');
  if(show_filters && hide_filters) {
    show_filters.addEventListener('click', handleClickShowFilter)
    hide_filters.addEventListener('click', handleClickHideFilter)
  }
};

topbarFilter();


initTheme();

document.addEventListener('shopify:section:load', (e) => {
  initCartDrawerControls();
  initTheme();
});

// Stock alert + badge Bodega US
(function () {
  // The PDP controller shares one inventory request with the inline form.
  if (document.querySelector('[data-notify-us-stock]')) return;
  const msg     = document.getElementById('alianza-stock-alert');
  const badge   = document.getElementById('bodega-stock-badge');
  const presale = document.getElementById('presale-badge');
  if (!msg && !badge && !presale) return;

  function check(variantId) {
    if (!variantId) return;
    fetch('https://mensaje-stock.dev-707.workers.dev?variant_id=' + variantId)
      .then(r => r.json())
      .then(d => {
        if (msg)     msg.style.display     = d.show_message     ? 'block' : 'none';
        if (badge)   badge.style.display   = d.has_bodega_stock ? 'block' : 'none';
        if (presale) presale.style.display = d.is_presale       ? 'block' : 'none';
      })
      .catch(() => {});
  }

  const initial = new URLSearchParams(location.search).get('variant')
    || document.querySelector('#ProductSelect-product-template')?.value;
  check(initial);

  document.addEventListener('variantChange', e => {
    if (e.detail?.variant?.id) check(e.detail.variant.id);
  });
})();
